const env = require("services/env");
const mobileBreakpoint = env.get("screen.mobileBreakpoint", 1160);

class Screen {

	get width() {
		return window.innerWidth;
	}

	get height() {
		return window.innerHeight;
	}

	mobile() {
		return this.width <= mobileBreakpoint;
	}

	desktop() {
		return this.width > mobileBreakpoint;
	}

}

module.exports = new Screen();


// WEBPACK FOOTER //
// ./resources/js/services/screen.js